import React, { useState } from "react";
import Profilecon from "../../../assets/images/profile/Partner/admin.png";

interface AdminManagementProps {
  isActive: boolean;
  onStatusChange: (isActive: boolean) => void;
  dateCreated: string;
  assignedAdmin: string;
  accountManager: string;
  accountManagerPhone: string;
  designation: string;
  internalNotes: string;
  onNotesChange: (notes: string) => void;
  contactFirstName: string;
  contactLastName: string;
  contactPhoneNumber: string;
  gender: string;
  setStatusLvl: React.Dispatch<React.SetStateAction<boolean>>;
  statusLvl: boolean;
  phoneVersion: string;
  lastLogin: string;
  referralCode: string;
  can_withdraw: boolean;
  can_edit_profile: boolean;
  handleSuspend: () => void;
}

const AdminManagement: React.FC<AdminManagementProps> = ({
  isActive,
  onStatusChange,
  dateCreated,
  assignedAdmin,
  accountManager,
  accountManagerPhone,
  designation,
  internalNotes,
  onNotesChange,
  contactFirstName,
  contactLastName,
  contactPhoneNumber,
  gender,
  setStatusLvl,
  statusLvl,
  phoneVersion,
  lastLogin,
  referralCode,
  can_edit_profile,
  can_withdraw,
  handleSuspend,
}) => {


  const [appVersion, osVersion, deviceId, deviceType] = phoneVersion?.split(
    ",",
  ) || ["nil", "nil", "nil", "nil"];

  return (
    <div className="bg-white rounded-xl p-6 shadow-sm">
      <div className="flex justify-start align-top gap-2">
        <img src={Profilecon} alt="Profilecon" className="h-6 w-6" />
        <h2 className="text-lg font-semibold text-gray-900 mb-6">
          Admin Management
        </h2>
      </div>

      <div className="space-y-5">
        <div className="flex items-start justify-start flex-col gap-2">
          <span className="text-sm text-[#0A0A0A]">Account Status</span>
          <div className="flex items-center justify-between w-full bg-[#F8FAFC] p-3 rounded-lg">
            <span
              className="text-base font-medium text-[#314158]"
              style={{ fontFamily: "Blinker" }}
            >
              {isActive ? "Account Active" : "Account Inactive"}
            </span>
            <label className="relative inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                checked={isActive}
                onChange={handleSuspend}
                className="sr-only peer"
              />
              <div className="w-11 h-6 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full peer-checked:bg-[#7c2ebd] after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border after:rounded-full after:h-5 after:w-5 after:transition-all"></div>
            </label>
          </div>
        </div>

        <div className="flex items-start justify-start flex-col gap-2">
          <label className="text-sm text-[#0A0A0A]">Date Created</label>
          <p
            className="text-base font-medium text-[#314158]  w-full bg-[#F8FAFC] p-3 rounded-lg"
            style={{ fontFamily: "Blinker" }}
          >
            {dateCreated}
          </p>
        </div>

        <div className="flex items-start justify-start flex-col gap-2">
          <label className="text-sm text-[#0A0A0A]">Assigned Admin</label>
          <p
            className="text-base font-medium text-[#314158]  w-full bg-[#F8FAFC] p-3 rounded-lg"
            style={{ fontFamily: "Blinker" }}
          >
            {assignedAdmin}
          </p>
        </div>

        <div className="flex items-start justify-start flex-col gap-2">
          <label className="text-sm text-[#0A0A0A]">Sourced By</label>
          <p
            className="text-base font-medium text-[#314158]  w-full bg-[#F8FAFC] p-3 rounded-lg"
            style={{ fontFamily: "Blinker" }}
          >
            {accountManager}
          </p>
        </div>

        <div className="flex items-start justify-start flex-col gap-2">
          <label className="text-sm text-[#0A0A0A]">Assigned Admin Phone</label>
          <div className="text-base font-medium text-[#314158]  w-full bg-[#F8FAFC] p-3 rounded-lg">
            <p>
               {accountManagerPhone}
            </p>
          </div>
        </div>

        <div className="flex items-start justify-start flex-col gap-2">
          <label className="text-sm text-[#0A0A0A]">Contact Person</label>
          <div className="text-base font-medium text-[#314158]  w-full bg-[#F8FAFC] p-3 rounded-lg">
            <p>
              {contactFirstName} {contactLastName} - {contactPhoneNumber}
            </p>
          </div>
        </div>

        <div className="flex items-start justify-start flex-col gap-2">
          <label className="text-sm text-[#0A0A0A]">Gender</label>
          <p
            className="text-base font-medium text-[#314158]  w-full bg-[#F8FAFC] p-3 rounded-lg"
            style={{ fontFamily: "Blinker" }}
          >
            {gender}
          </p>
        </div>

        <div className="flex items-start justify-start flex-col gap-2">
          <label className="text-sm text-[#0A0A0A]">Designation</label>
          <p
            className="text-base font-medium text-[#314158]  w-full bg-[#F8FAFC] p-3 rounded-lg"
            style={{ fontFamily: "Blinker" }}
          >
            {designation}
          </p>
        </div>

        <div className="flex items-start justify-start flex-col gap-2">
          <label className="text-sm text-[#0A0A0A]">Device Version</label>
          <p
            className="text-base font-medium text-[#314158]  w-full bg-[#F8FAFC] p-3 rounded-lg"
            style={{ fontFamily: "Blinker" }}
          >
            {deviceType?.trim()}
          </p>
        </div>

         <div className="flex items-start justify-start flex-col gap-2">
          <label className="text-sm text-[#0A0A0A]">Current App Version</label>
          <p
            className="text-base font-medium text-[#314158]  w-full bg-[#F8FAFC] p-3 rounded-lg"
            style={{ fontFamily: "Blinker" }}
          >
            {appVersion?.trim()}
          </p>
        </div>

         <div className="flex items-start justify-start flex-col gap-2">
          <label className="text-sm text-[#0A0A0A]">Device OS Version</label>
          <p
            className="text-base font-medium text-[#314158]  w-full bg-[#F8FAFC] p-3 rounded-lg"
            style={{ fontFamily: "Blinker" }}
          >
            {osVersion?.trim()}
          </p>
        </div>

         <div className="flex items-start justify-start flex-col gap-2">
          <label className="text-sm text-[#0A0A0A]">Device ID</label>
          <p
            className="text-base font-medium text-[#314158]  w-full bg-[#F8FAFC] p-3 rounded-lg"
            style={{ fontFamily: "Blinker" }}
          >
            {deviceId?.trim()}
          </p>
        </div>

        <div className="flex items-start justify-start flex-col gap-2">
          <label className="text-sm text-[#0A0A0A]">Can Edit Profile</label>
          <p
            className="text-base font-medium text-[#314158]  w-full bg-[#F8FAFC] p-3 rounded-lg"
            style={{ fontFamily: "Blinker" }}
          >
            {can_edit_profile ? 'Yes' : 'No'}
          </p>
        </div>

        <div className="flex items-start justify-start flex-col gap-2">
          <label className="text-sm text-[#0A0A0A]">Can Withdraw</label>
          <p
            className="text-base font-medium text-[#314158]  w-full bg-[#F8FAFC] p-3 rounded-lg"
            style={{ fontFamily: "Blinker" }}
          >
            {can_withdraw ? 'Yes' : 'No'}
          </p>
        </div>

        

        <div className="flex items-start justify-start flex-col gap-2">
          <label className="text-sm text-[#0A0A0A]">Last Login</label>
          <p
            className="text-base font-medium text-[#314158]  w-full bg-[#F8FAFC] p-3 rounded-lg"
            style={{ fontFamily: "Blinker" }}
          >
            {lastLogin}
          </p>
        </div>

        <div className="flex items-start justify-start flex-col gap-2">
          <label className="text-sm text-[#0A0A0A]">Referral Code</label>
          <p
            className="text-base font-medium text-[#314158]  w-full bg-[#F8FAFC] p-3 rounded-lg"
            style={{ fontFamily: "Blinker" }}
          >
            {referralCode}
          </p>
        </div>

        {/* <div className="flex items-start justify-start flex-col gap-2">
          <label className="text-sm text-[#0A0A0A]">Internal Notes</label>
          <textarea
            placeholder="Add internal notes..."
            value={internalNotes}
            onChange={(e) => onNotesChange(e.target.value)}
            className="w-full px-3 py-2 border border-gray-200 rounded-lg bg-gray-50 text-sm text-gray-700 resize-none"
            rows={3}
          />
        </div> */}
      </div>
    </div>
  );
};

export default AdminManagement;
